<script setup>
import { computed } from 'vue';
import { Building2, BadgeCheck, CircleAlert } from 'lucide-vue-next';
import PdRadioCard from '../PdRadioCard.vue';
import { mask } from '../../data/format.js';

/** One selectable recipient. beneficiary uses transaction_beneficiary fields. */
const model = defineModel({ type: [String, Number], default: null });
const props = defineProps({
  beneficiary: { type: Object, required: true },
  name: { type: String, default: 'recipient' },
});
const verified = computed(() => props.beneficiary.rant_id && props.beneficiary.rant_id !== 'N');
const meta = computed(() => `${props.beneficiary.bank_name} · ${mask(props.beneficiary.bank_account_number)} · ${props.beneficiary.bank_branch_ifsc}`);
const paymentCount = computed(() => Number(props.beneficiary.total_transactions_processed) || 0);
const usage = computed(() => paymentCount.value === 1 ? 'Paid once' : `Paid ${paymentCount.value} times`);
</script>

<template>
  <PdRadioCard v-model="model" :value="beneficiary.beneficiary_id" :name="name" :title="beneficiary.bank_account_name" :meta="meta" :icon="Building2">
    <span class="pd-ro__details">
      <span class="pd-ro__flag" :class="verified ? 'is-ok' : 'is-no'">
        <component :is="verified ? BadgeCheck : CircleAlert" :size="14" :stroke-width="2.5" aria-hidden="true" />
        {{ verified ? 'Verified account' : 'Account not verified yet' }}
      </span>
      <span v-if="beneficiary.total_transactions_processed != null" class="pd-ro__usage pd-num">{{ usage }}</span>
    </span>
  </PdRadioCard>
</template>

<style scoped>
.pd-ro__details { display: flex; flex-wrap: wrap; align-items: center; gap: 5px 12px; margin-top: 4px; }
.pd-ro__flag { display: inline-flex; align-items: center; gap: 5px; font-size: 0.75rem; font-weight: 800; }
.pd-ro__usage { font-size: 0.75rem; font-weight: 700; color: var(--pd-muted); }
.pd-ro__usage::before { content: ''; display: inline-block; width: 3px; height: 3px; margin: 0 7px 2px 0; border-radius: 50%; background: currentColor; opacity: 0.55; }
.is-ok { color: var(--pd-success); }
.is-no { color: var(--pd-warning); }
</style>
